// extracted by mini-css-extract-plugin
export default {"payContainer":"paymentForm_payContainer__XPl1r"};